import Vue from 'vue'
import _ from 'lodash'
export default {
  namespaced: true,
  state: {
    navigationGuardianCheckData: {},
    navigationGuardianChangeData: {},
    navigationGuardianChangeDataModal: {
      active: false,
      to: null,
    },
    navigationGuardianCheckDataWait: 0,
  },
  mutations: {
    setNavigationGuardianCheckData(state, payload) {
      state.navigationGuardianCheckData = payload
    },
    setNavigationGuardianChangeData(state, payload) {
      state.navigationGuardianChangeData = payload
    },
    setNavigationGuardianChangeDataModal(state, payload) {
      state.navigationGuardianChangeDataModal = payload
    },
  },
  getters: {
    navigationGuardianActive: (state) => {
      const changeData = state.navigationGuardianChangeData
      let result = false
      if (Object.keys(changeData).length) {
        for (let changeKey in changeData) {
          let changeItem = changeData[changeKey]
          if (Array.isArray(changeItem) && changeItem.length) {
            for (let itemKey in changeItem) {
              if (changeItem[itemKey]) {
                result = true
                break
              }
            }
          } else if (!Array.isArray(changeItem) && changeItem) {
            result = true
            break
          }
        }
      }
      return result
    },
    navigationGuardianChangeData: (state) => {
      return state.navigationGuardianChangeData
    }
  },
  actions: {
    onNavigationGuardianCheck({ commit, state, dispatch }, { data, overwrite, editingArrayData }) {
      if (state.navigationGuardianCheckDataWait === 0) {
        state.navigationGuardianCheckDataWait = state.navigationGuardianCheckDataWait + 1
        let checkData = state.navigationGuardianCheckData
        let changeData = state.navigationGuardianChangeData
        // console.log('NavigationGuardianCheckData', {
        //   old: checkData,
        //   new: data,
        //   editingArrayData,
        //   overwrite,
        // })
        for (let mainKey in data) {
          if (overwrite) {
            if (Array.isArray(data[mainKey])) {
              Vue.set(checkData, mainKey, [])
              Vue.set(changeData, mainKey, [])
              for (let itemKey in data[mainKey]) {
                Vue.set(checkData[mainKey], itemKey, _.cloneDeep(data[mainKey][itemKey]))
                Vue.set(changeData[mainKey], itemKey, false)
              }
            } else {
              Vue.set(checkData, mainKey, _.cloneDeep(data[mainKey]))
              Vue.set(changeData, mainKey, false)
            }
          } else {
            if (Array.isArray(data[mainKey])) {
              if (!checkData[mainKey]) {
                if (!changeData[mainKey]) {
                  Vue.set(changeData, mainKey, [])
                  if (editingArrayData) {
                    Vue.set(changeData[mainKey], editingArrayData.key, true)
                  } else {
                    for (let itemKey in data[mainKey]) {
                      Vue.set(changeData[mainKey], itemKey, true)
                    }
                  }
                }
              } else {
                if (editingArrayData) {
                  if (editingArrayData.type === 'add') {
                    if (!changeData[mainKey][editingArrayData.key]) {
                      Vue.set(changeData[mainKey], editingArrayData.key, 'add')
                    }
                  } else if (editingArrayData.type === 'edit') {
                    if (
                      !_.isEqual(
                        checkData[mainKey][editingArrayData.key],
                        data[mainKey][editingArrayData.key],
                      )
                    ) {
                      Vue.set(changeData[mainKey], editingArrayData.key, 'edit')
                    } else {
                      Vue.set(changeData[mainKey], editingArrayData.key, false)
                    }
                  } else if (editingArrayData.type === 'delete') {
                    if (!checkData[mainKey][editingArrayData.key]) {
                      Vue.delete(changeData[mainKey], editingArrayData.key)
                    } else {
                      Vue.set(changeData[mainKey], editingArrayData.key, 'delete')
                    }
                  }
                } else {
                  if (data[mainKey].length != changeData[mainKey].length) {
                    if (data[mainKey].length > changeData[mainKey].length) {
                      for (let itemKey in data[mainKey]) {
                        if (!checkData[mainKey][itemKey]) {
                          if (!changeData[mainKey][itemKey]) {
                            Vue.set(changeData[mainKey], itemKey, true)
                            break
                          }
                        }
                      }
                    } else if (data[mainKey].length < changeData[mainKey].length) {
                      for (let itemKey in changeData[mainKey]) {
                        if (!data[mainKey][itemKey]) {
                          Vue.delete(changeData[mainKey], itemKey)
                          break
                        }
                      }
                    }
                  } else {
                    for (let itemKey in data[mainKey]) {
                      // console.log('data[mainKey][itemKey]', data[mainKey][itemKey])
                      for (let arrayItemKey in data[mainKey][itemKey]) {
                        // if (
                        //   checkData[mainKey][itemKey] &&
                        //   checkData[mainKey][itemKey][arrayItemKey]
                        // ) {
                          if (
                            !Object.is(
                              checkData[mainKey][itemKey][arrayItemKey],
                              data[mainKey][itemKey][arrayItemKey],
                            )
                          ) {
                            Vue.set(changeData[mainKey], itemKey, true)
                            break
                          } else {
                            Vue.set(changeData[mainKey], itemKey, false)
                          }
                        // }
                      }
                    }
                  }
                }
              }
            } else {
              if (!_.isEqual(checkData[mainKey], data[mainKey])) {
                Vue.set(changeData, mainKey, true)
              } else {
                Vue.set(changeData, mainKey, false)
              }
            }
          }
        }
        state.navigationGuardianCheckDataWait = state.navigationGuardianCheckDataWait - 1
      } else {
        if (state.navigationGuardianCheckDataWait > 0) {
          console.log('else', state.navigationGuardianCheckDataWait)
          state.navigationGuardianCheckDataWait = state.navigationGuardianCheckDataWait - 1
          dispatch('onNavigationGuardianCheck', { data, overwrite, editingArrayData })
        }
      }

      // if (state.navigationGuardianCheckData === null) {
      //   let checkData = {}
      //   for (let key in data) {
      //     if (!checkData[key]) {
      //       checkData[key] = data[key]
      //     }
      //   }
      //   commit('setNavigationGuardianCheckData', checkData)
      // } else {
      //   let checkData = state.navigationGuardianCheckData
      //   for (let key in data) {
      //     if (!checkData[key]) {
      //       checkData[key] = data[key]
      //     }
      //   }
      //   commit('setNavigationGuardianCheckData', checkData)
      // }
      // for (let key in data) {
      //   if (state.navigationGuardianCheckData[key] != data[key]) {
      //     commit('setNavigationGuardianChangeData', true)
      //     break
      //   }
      // }
    },
    // onNavigationGuardianCheck({ commit, state }, { data, overwrite }) {
    //   let checkData = state.navigationGuardianCheckData
    //   let changeData = state.navigationGuardianChangeData
    //   function deepCompare({ oldObj, newObj, changeObj, depthLevel }) {
    //     console.log('deepCompare', { oldObj, newObj, changeObj, depthLevel })
    //     for (let key in newObj) {
    //       if ((!oldObj[key] || overwrite) && depthLevel < 3) {
    //         if (Array.isArray(newObj[key])) {
    //           Vue.set(oldObj, key, [])
    //           Vue.set(changeData, key, [])
    //           if (newObj.length) {
    //             deepCompare({
    //               oldObj: oldObj[key],
    //               newObj: newObj[key],
    //               changeObj: changeObj[key],
    //               depthLevel: depthLevel + 1,
    //             })
    //           }
    //         } else if (typeof newObj[key] === 'object' && newObj[key] !== null) {
    //           console.log('zae*******' + key, newObj[key])
    //           // oldObj[key] = {}
    //           Vue.set(oldObj, key, {})
    //           if (depthLevel === 1) {
    //             Vue.set(changeData, key, false)
    //           }
    //           Vue.set(changeData, key, {})
    //           if (depthLevel === 1) {
    //             Vue.set(changeData, key, false)
    //           }

    //           if (Object.keys(newObj).length) {
    //             deepCompare({
    //               oldObj: oldObj[key],
    //               newObj: newObj[key],
    //               changeObj: changeObj[key],
    //               depthLevel: depthLevel + 1,
    //             })
    //           }
    //         } else {
    //           // Vue.set(checkObj, key, false)
    //           // Vue.set(checkObj, key, false)
    //         }
    //       }
    //       // else {
    //       //   if (!Array.isArray(newObj[key]) && typeof newObj[key] !== 'object') {
    //       //     if (newObj[key] !== oldObj[key]) {
    //       //       // for (let itemKey in newObj[key]) {
    //       //       //   oldObj[key][itemKey] = newObj[key][itemKey]
    //       //       //   commit('setNavigationGuardianCheckData', checkData)
    //       //       // }
    //       //       Vue.set(changeData, key, false)

    //       //       if (depthLevel == 0) Vue.set(changeData, key, false)
    //       //     }
    //       //   } else {
    //       //     if (Array.isArray(newObj[key])) {
    //       //       if (depthLevel === 1 && !oldObj[key]) {
    //       //         Vue.set(checkObj, key, false)
    //       //         Vue.set(changeData, key, false)
    //       //       }
    //       //     } else {
    //       //     }
    //       //   }
    //       // }
    //     }
    //   }
    //   deepCompare({
    //     oldObj: checkData,
    //     newObj: data,
    //     changeObj: changeData,
    //     depthLevel: 0,
    //   })

    //   // for (let mainKey in data) {
    //   //   if (!checkData[mainKey] || overwrite) {
    //   //     if (Array.isArray(data[mainKey])) {
    //   //       checkData[mainKey] = []
    //   //       Vue.set(changeData, mainKey, [])
    //   //       for (let itemKey in data[mainKey]) {
    //   //         checkData[mainKey].push(data[mainKey][itemKey])
    //   //         Vue.set(changeData[mainKey], itemKey, false)
    //   //       }
    //   //       commit('setNavigationGuardianCheckData', checkData)
    //   //     } else {
    //   //       checkData[mainKey] = {}
    //   //       for (let itemKey in data[mainKey]) {
    //   //         checkData[mainKey][itemKey] = data[mainKey][itemKey]
    //   //         commit('setNavigationGuardianCheckData', checkData)
    //   //       }
    //   //       Vue.set(changeData, mainKey, false)
    //   //     }
    //   //   } else {
    //   //     console.log(deepCompare({oldObj: checkData[mainKey],newObj: data[mainKey]}))
    //   //     for (let itemKey in data[mainKey]) {
    //   //       if (Array.isArray(data[mainKey])) {
    //   //       } else {
    //   //         if (checkData[mainKey][itemKey] != data[mainKey][itemKey]) {
    //   //           Vue.set(changeData, mainKey, true)
    //   //           break
    //   //         } else {
    //   //           Vue.set(changeData, mainKey, false)
    //   //         }
    //   //       }
    //   //     }
    //   //   }
    //   // }

    //   // if (state.navigationGuardianCheckData === null) {
    //   //   let checkData = {}
    //   //   for (let key in data) {
    //   //     if (!checkData[key]) {
    //   //       checkData[key] = data[key]
    //   //     }
    //   //   }
    //   //   commit('setNavigationGuardianCheckData', checkData)
    //   // } else {
    //   //   let checkData = state.navigationGuardianCheckData
    //   //   for (let key in data) {
    //   //     if (!checkData[key]) {
    //   //       checkData[key] = data[key]
    //   //     }
    //   //   }
    //   //   commit('setNavigationGuardianCheckData', checkData)
    //   // }
    //   // for (let key in data) {
    //   //   if (state.navigationGuardianCheckData[key] != data[key]) {
    //   //     commit('setNavigationGuardianChangeData', true)
    //   //     break
    //   //   }
    //   // }
    //   // console.log('NavigationGuardianCheckData', {
    //   //   old: state.navigationGuardianCheckData,
    //   //   new: data,
    //   // })
    // },
    offNavigationGuardianCheck({ commit }) {
      commit('setNavigationGuardianChangeData', {})
      commit('setNavigationGuardianChangeDataModal', { active: false, to: null })
      commit('setNavigationGuardianCheckData', {})
      return true
    },
  },
}
